import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useCallback, useState } from 'react';
import { uniqueId } from 'lodash';
import { createPortal } from 'react-dom';
import { usePubSub } from '../../hooks/usePubSub';
import { BannerContext } from './BannerContext';
import { BannerList } from './BannerList';
import { TOPICS } from './constants';
export var BannerManager = function BannerManager(_ref) {
  var children = _ref.children,
      _ref$container = _ref.container,
      container = _ref$container === void 0 ? document.body : _ref$container;

  var _useState = useState([]),
      banners = _useState[0],
      setBanners = _useState[1];

  var removeBanner = useCallback(function (id) {
    return setBanners(function (prevBanners) {
      return prevBanners.filter(function (t) {
        return t.id !== id;
      });
    });
  }, []);
  var showBanner = useCallback(function (t) {
    var banner = _extends({
      id: uniqueId()
    }, t);

    var cleanup = function cleanup() {
      return removeBanner(banner.id);
    };

    setBanners(function (prevBanners) {
      // Don't re-add a pre-existing banner to the list.
      if (prevBanners.some(function (_ref2) {
        var id = _ref2.id;
        return id === banner.id;
      })) {
        return prevBanners;
      }

      return [banner].concat(prevBanners);
    }); // Return the cleanup function which basically
    // let you remove the banner manually

    return cleanup;
  }, [removeBanner]); // Handle events that are coming from outside the React Tree.

  usePubSub(TOPICS.SHOW_BANNER, showBanner);
  usePubSub(TOPICS.REMOVE_BANNER, removeBanner);
  var containerNode = typeof container === 'function' ? container() : container;
  return /*#__PURE__*/React.createElement(BannerContext.Provider, {
    value: {
      banners: banners,
      showBanner: showBanner,
      removeBanner: removeBanner
    }
  }, /*#__PURE__*/React.createElement(React.Fragment, null, children, containerNode && /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(BannerList, null), containerNode)));
};